import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";
import { TableCell } from "@mui/material";

interface IAreaForm {
	gridTemplateColumns?: string;
}

const ContainerSection = styled.div`
	background-color: ${({ theme }) => theme.pantone656C};
	padding: 1rem;
	border-radius: 6px;
	margin: 0 0 2rem 0;
`;

export const Container = styled(ContainerSection)`
	@media (max-width: 426px) {
		button {
			width: 100%;
			max-width: 100%;
			padding: 0.4rem 0 !important;
			margin: 0;
		}
	}
`;

export const ContainerBodyHistory = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	max-height: 280px;
	overflow: auto;
`;

export const AreaForm = styled.div<IAreaForm>`
	display: grid;
	grid-template-columns: ${(props) => props.gridTemplateColumns || "1fr 1fr 1fr 1fr"};
	gap: 1rem;

	@media (max-width: 426px) {
		grid-template-columns: 1fr;

		button {
			width: 100%;
			max-width: 100%;
			padding: 0.4rem 0 !important;
			margin: 0;
		}
	}
`;

export const AreaError = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;

	> p {
		margin: 0 0 0 0.4rem;
	}
`;

export const IconClose = styled(CloseIcon)`
	&&& {
		cursor: pointer;
	}
`;

export const TableCellMobile = styled(TableCell)`
	&&& {
		@media (max-width: 426px) {
			min-width: 200px;
		}
	}
`;

export const TableIcons = styled.div`
	display: flex;
	justify-content: end;
	align-items: center;
	gap: 15px;
`;
